import {type BucketedLine} from '../types';

type CachedBucketedPayload = {
  histories: {data: BucketedLine[]};
  isAggregated?: Record<string, boolean>;
  fetchedRunCount?: number;
};

// Read container lengths only; never visit point values or serialize the payload.
export function describeBucketedCachePayload(data: CachedBucketedPayload) {
  let historyRowCount = 0;
  let columnarRowCount = 0;
  let backendLineCount = 0;
  let backendPointCount = 0;
  let backendAreaPointCount = 0;
  let backendSmoothedPointCount = 0;
  let backendNonFinitePointCount = 0;
  for (const run of data.histories.data) {
    for (const history of run.history ?? []) {
      historyRowCount += history.length;
    }
    for (const history of run.historyColumnar ?? []) {
      columnarRowCount += history.numRows;
    }
    for (const line of run.historyLines ?? []) {
      backendLineCount++;
      backendPointCount += line.historyLine.length;
      backendAreaPointCount += line.areaLine.length;
      backendSmoothedPointCount += line.smoothedLine?.length ?? 0;
      backendNonFinitePointCount += line.nonFiniteLine.length;
    }
  }
  return {
    payloadRunOrGroupCount: data.histories.data.length,
    ...(data.fetchedRunCount == null
      ? {}
      : {payloadFetchedRunCount: data.fetchedRunCount}),
    payloadBackendGrouped: Object.values(data.isAggregated ?? {}).some(Boolean),
    historyRowCount,
    columnarRowCount,
    backendLineCount,
    backendPointCount,
    backendAreaPointCount,
    backendSmoothedPointCount,
    backendNonFinitePointCount,
  };
}

export function isBucketedCacheUsable(data: CachedBucketedPayload) {
  return data.histories.data.length > 0;
}
